// extracted by mini-css-extract-plugin
export default {"modal":"SuccessModal_modal__Ol+9f","yes-btn":"SuccessModal_yes-btn__awsuz"};